export default {
  messages: {
    other: 'cn其他',
    hello: '{word} 哈啰！',
  },
};
